/** Host-owned navigation for explicit insight targets; display IDs/labels are never interpreted as URLs. */
import type { InsightEntity } from '@testfeed/shopify-contracts'
import { buildShopifyAdminProductUrl } from './shopify-admin-product-url'

export function buildShopifyAdminEntityUrl(target: NonNullable<InsightEntity['target']>): string | null {
  if (target.kind === 'shopify-product') return buildShopifyAdminProductUrl(target.productId, target.variantId)
  const order = target.orderId.trim().match(/^(?:gid:\/\/shopify\/Order\/)?(\d+)$/)
  return order ? `shopify://admin/orders/${order[1]}` : null
}
